export default [
  { name: 'Arica and Parinacota', code: 'AP' },
  { name: 'Tarapacá', code: 'TA' },
  { name: 'Antofagasta', code: 'AN' },
  { name: 'Atacama', code: 'AT' },
  { name: 'Coquimbo', code: 'CO' },
  { name: 'Valparaíso', code: 'VS' },
  { name: 'Santiago', code: 'RM' },
  { name: 'O’Higgins', code: 'LI' },
  { name: 'Maule', code: 'ML' },
  { name: 'Ñuble', code: 'NB' },
  { name: 'Biobío', code: 'BI' },
  { name: 'Araucanía', code: 'AR' },
  { name: 'Los Ríos', code: 'LR' },
  { name: 'Los Lagos', code: 'LL' },
  { name: 'Aysén', code: 'AI' },
  { name: 'Magallanes', code: 'MA' }
];
